import * as React from 'react';
import { ContentField } from '@box/blueprint-web';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import {
  FolderPersonal,
  FolderShared,
} from '@box/blueprint-web-assets/icons/Content';
import { Folder } from '@box/blueprint-web-assets/icons/Fill';
import type { FolderInfo } from '../../../types/form/FolderInfo';

import messages from './messages';
import css from './folder-selection-content-field.module.scss';

// reflects props of blueprint ContentField Component
// https://git.dev.box.net/Box/frontend-mono/blob/master/packages/blueprint-web/src/lib/content-field/types.ts
type Props = {
  error?: string | null;
  hintText: string;
  // custom prop, used to determine which folder icon is shown
  folderInfo?: FolderInfo | null;
  onClick: (...args: unknown[]) => unknown;
  onClickClearButton: (...args: unknown[]) => unknown;
  clearButtonAriaLabel?: string;
  title?: string | null;
  intl: IntlShape;
};

const FolderSelectionContentField = (props: Props) => {
  const { folderInfo, intl } = props;

  const getFolderName = () => {
    if (folderInfo) {
      return folderInfo.name;
    }
    return props.title;
  };

  const getFolderIcon = (selectedFolder: FolderInfo | null | undefined) => {
    if (!selectedFolder) {
      return (
        <div className={css.fillIconContainer}>
          <Folder
            className={css.fillIcon}
            aria-label={intl.formatMessage(messages.defaultFolderAriaLabel)}
          />
        </div>
      );
    }
    if (selectedFolder.isSharedFolder)
      return (
        <FolderShared
          className={css.contentIcon}
          aria-label={intl.formatMessage(messages.sharedFolderAriaLabel)}
        />
      );
    return (
      <FolderPersonal
        className={css.contentIcon}
        aria-label={intl.formatMessage(messages.personalFolderAriaLabel)}
      />
    );
  };

  return (
    <ContentField
      {...props}
      itemIcon={getFolderIcon(folderInfo)}
      // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
      title={getFolderName()}
    />
  );
};

type WrappedProps = Omit<Props, 'intl'>;
const Wrapped = injectIntl(FolderSelectionContentField);
export default Wrapped as React.ComponentType<WrappedProps>;
